<template>
  <div class="voice-room-main">
    <div class="main">
      <game-detail ref="gameDetail"></game-detail>
      <action-page
        ref="actionPage"
        class="action-page"
        @hanleSendGift="sendGift"
      ></action-page>
      <video-player class="im-video"></video-player>
    </div>
  </div>
</template>
<script>
import ActionPage from './action-page.vue';
import VideoPlayer from '@/components/VoiceRoom/component/video.vue';
import GameDetail from './game-detail.vue';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';

export default {
  components: {
    ActionPage,
    VideoPlayer,
    GameDetail
  },
  name: 'VoiceRoomMain',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    async sendGift() {
      const list = await VoiceRoomIM.getImMembersProfile(this.getSeatUsers());
      if (list && list.length) {
        const users = list.map(item => {
          return {
            isSelect: false,
            user: {
              avatarURL: item.avatar,
              userUuid: item.userID
            }
          };
        });
        console.log(users);
        this.$refs.actionPage.sendGift(users, false);
      } else {
        this.$refs.actionPage.sendGift([], false);
      }
    },
    getSeatUsers() {
      if (this.$refs.gameDetail) {
        return this.$refs.gameDetail.getSeatUsers();
      } else {
        return [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.voice-room-main {
  width: 520px;
  background-size: cover;
  border-radius: 20px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}
.main {
  width: 100%;
  height: 100%;
  background-color: rgba(21, 32, 44, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  background-size: cover;
}
.im-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.action-page {
  position: absolute;
  bottom: 0;
  z-index: 2;
}
</style>
<style lang="scss">
.im-video {
  canvas: {
    pointer-events: none;
  }
}
</style>
